import WishlistActions from '@/components/WishlistActions/WishlistActions.vue';
import { mountCoreVueApp } from '@/entrypoints/helpers/core-vue-app';
import GlobalKeyDownDirective from '@/shared/directives/globalKeyDown';
import { useUserStore } from '@/shared/pinia/modules/user';
import { useWishlistStore } from '@/shared/pinia/modules/wishlist';
import { notifyBugsnagWithContext } from '@/shared/utils/error';

const IS_DEV = import.meta.env.DEV;

// Track initialization to prevent multiple apps
let isInitialized = false;
let currentApp = null;

export const initWishlistActions = async (mountId) => {
  if (!document.getElementById(mountId) || isInitialized) {
    return;
  }

  isInitialized = true;

  const appDecorator = (app) => {
    app.directive('global-keydown', GlobalKeyDownDirective);
  };

  try {
    currentApp = await mountCoreVueApp(
      WishlistActions,
      `#${mountId}`,
      {},
      appDecorator
    );

    const userStore = useUserStore();
    if (userStore.isLogged) {
      const wishlistStore = useWishlistStore();
      try {
        await wishlistStore.loadWishlistItems();
      } catch (error) {
        notifyBugsnagWithContext('[wishlist-button]', error, {
          message: 'Failed to load wishlist data'
        });
        if (IS_DEV) {
          console.error(
            '[wishlist-button] Failed to load wishlist data:',
            error
          );
        }
      }
    }
  } catch (error) {
    notifyBugsnagWithContext('[wishlist-button]', error, {
      message: 'Failed to mount'
    });
    if (IS_DEV) {
      console.error('[wishlist-button] Failed to mount:', error);
    }
    isInitialized = false; // Reset on error to allow retry
  }
};

// Cleanup function for page navigation
export const cleanupWishlistActions = () => {
  if (currentApp && typeof currentApp.unmount === 'function') {
    currentApp.unmount();
    currentApp = null;
  }
  isInitialized = false;
};

// Reset on page unload
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', cleanupWishlistActions);
}
